import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Params } from '@angular/router';
import { PriceConstantsEnum } from '@qaroni-app/payments/types/price-constants.enum';

@Component({
  selector: 'qaroni-payments-card-subscribe-button',
  templateUrl: './payments-card-subscribe-button.component.html',
  styleUrls: ['./payments-card-subscribe-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsCardSubscribeButtonComponent {
  readonly isMonthly = input<boolean>(true);

  get frequencyParam(): Params {
    return {
      frequency: this.isMonthly()
        ? PriceConstantsEnum.MONTH
        : PriceConstantsEnum.YEAR,
    };
  }
}
